import React, { useState, useEffect } from 'react';

function horizontalSpacer(width) {
  return <div style={{ display: "inline-block", width: width }}></div>;
}

function verticalSpacer(height) {
  return <div style={{ height: height }}></div>;
}

function useWindowSize() {
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }
    
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowSize;
}

const ProductImageUploadPage = () => {
  const apiKey = process.env.REACT_APP_API_KEY;
const urlParams = new URLSearchParams(window.location.search);
  const [pid, setPid] = useState('');
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [previewUrls, setPreviewUrls] = useState([]);
  const [uploadedImages, setUploadedImages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const windowSize = useWindowSize();

  useEffect(() => {
    const productUrl = urlParams.get('productID');
    
    if (productUrl) {
        try {
            const produrtURLID = JSON.parse(productUrl);
            setPid(produrtURLID);
        } catch (error) {
        }
    }
  }, []);

  // Fetch existing images when pid changes
  useEffect(() => {
    if (pid) {
      fetchProductImages();
    } else {
      setUploadedImages([]);
    }
  }, [pid]);

  const fetchProductImages = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}api/users/product-images/${pid}`);
      if (response.ok) {
        const imageUrls = await response.json();
        setUploadedImages(imageUrls);
      }
    } catch (error) {
      console.error('Error fetching images:', error);
    }
  };

  const handleFileSelect = (e) => {
    const files = Array.from(e.target.files);
    setSelectedFiles(files);

    // Create preview URLs
    const previews = files.map(file => URL.createObjectURL(file));
    setPreviewUrls(previews);
  };

  const handleUpload = async (e) => {
    e.preventDefault();

    if (!pid) {
      setMessage('Please enter a Product ID');
      return;
    }

    if (selectedFiles.length === 0) {
      setMessage('Please select at least one image');
      return;
    }

    setLoading(true);
    setMessage('');

    const formData = new FormData();
    formData.append('api_key', apiKey);
    formData.append('pid', pid);
    
    
    selectedFiles.forEach((file) => {
      formData.append('images', file);
    });

    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}api/users/upload-images`, {
        method: 'POST',
        body: formData,
      });

      if (response.ok) {
        setMessage('Upload successful!');
        setSelectedFiles([]);
        setPreviewUrls([]);
        // Clear the file input
        document.getElementById('fileInput').value = '';
        // Refresh the uploaded images
        fetchProductImages();
      } else {
        setMessage('Upload failed. Please try again.');
      }
    } catch (error) {
      console.error('Error uploading:', error);
      setMessage('Error uploading images');
    } finally {
      setLoading(false);
    }
  };

  const removePreview = (index) => {
    const newFiles = selectedFiles.filter((_, i) => i !== index);
    const newPreviews = previewUrls.filter((_, i) => i !== index);
    setSelectedFiles(newFiles);
    setPreviewUrls(newPreviews);
  };

  return (
    <div>
    <div className="upload-container">
      <h2>Product Image Upload</h2>
      
      <form onSubmit={handleUpload} className="upload-form">
        <div className="form-group">
          <label htmlFor="pid">Product ID:</label>
          <input
            type="text"
            id="pid"
            value={pid}
            onChange={(e) => setPid(e.target.value)}
            placeholder= {pid === '' ? "Enter Product ID" : pid}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="fileInput">Select Images:</label>
          <input
            type="file"
            id="fileInput"
            multiple
            accept="image/*"
            onChange={handleFileSelect}
          />
        </div>

        {previewUrls.length > 0 && (
          <div className="preview-section">
            <h3>Selected Images ({previewUrls.length})</h3>
            <div className="preview-grid">
              {previewUrls.map((url, index) => (
                <div key={index} className="preview-item">
                  <img src={url} alt={`Preview ${index + 1}`} />
                  <button
                    type="button"
                    className="remove-btn"
                    onClick={() => removePreview(index)}
                  >
                    ×
                  </button>
                  <span className="file-name">{selectedFiles[index].name}</span>
                </div>
              ))}
            </div>
          </div>
        )}

        <button type="submit" className="upload-btn" disabled={loading}>
          {loading ? 'Uploading...' : 'Upload Images'}
        </button>

        {message && (
          <div className={`message ${message.includes('successful') ? 'success' : 'error'}`}>
            {message}
          </div>
        )}
      </form>

      {uploadedImages.length > 0 && (
        <div className="uploaded-section">
          <h3>Uploaded Images for Product {pid}</h3>
          <div className="uploaded-grid">
            {uploadedImages.map((url, index) => (
              <div key={index} className="uploaded-item">
                <img src={url} alt={`Product ${pid} - ${index + 1}`} />
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
    {verticalSpacer((windowSize.width * 0.1) + (windowSize.height * 0.2))}
    </div>
  );
};

export default ProductImageUploadPage;